import {
    Component,
    inject,
    OnInit
} from '@angular/core';

import {
    RouterOutlet
} from '@angular/router';

import {
    Sidebar
} from '../sidebar/sidebar';

import {
    Topbar
} from '../topbar/topbar';

import {
    RestaurantContextService
} from '../../core/restaurant/services/restaurant-context.service';


@Component({
    selector: 'app-app-layout',

    imports: [
        RouterOutlet,
        Sidebar,
        Topbar
    ],

    templateUrl: './app-layout.html',
    styleUrl: './app-layout.css'
})
export class AppLayout implements OnInit {

    private readonly restaurantContext =
        inject(
            RestaurantContextService
        );


    sidebarOpen = false;


    ngOnInit(): void {

        /*
         * Al ingresar al área privada,
         * cargamos los restaurantes disponibles
         * para el usuario autenticado.
         */
        this.restaurantContext
            .loadRestaurants();
    }


    toggleSidebar(): void {

        this.sidebarOpen =
            !this.sidebarOpen;
    }


    closeSidebar(): void {

        this.sidebarOpen =
            false;
    }
}